export default __webpack_public_path__ + "57d7c8ebe26478179766c432a750aad0.png";